
<app-bread-crumb [items]="[{text:'noticias'}]" [sectionTitle]="'Lista de Notícias'"></app-bread-crumb>

<section class="content">
  <div class="row">
    <div class="col-md-12">
      <!-- inicio do box -->
      <ng-box [boxIcon]="'fa fa-newspaper-o'" [boxTitle]="'Notícias'">

        <!-- cabesalho do box -->
        <ng-container class="ng-box-header">
          <a *ngIf="isAll()" routerLink="/admin/news/new" class="btn btn-outline-danger pull-right"> <i class="fa fa-plus"></i>
            Nova Notícia
          </a>
        </ng-container>

        <!-- conteudo do box -->
        <ng-container class="ng-box-content">

          <ng-table  [tableHeaderAndFooterColumns]="tableProprieties()" *ngIf="!isSpinnerLoading">

                <tr *ngFor="let new of objects;index" ngChangeColorOnHover>

                  <td>
                    <span style="font-size:medium;color:#f35309">{{new?.title}}</span>
                  </td>

                  <td>{{new?.createdAt}}</td>
                  <td>{{new?.comments?.length}}</td>
                  <td *ngIf="this.isAdminOrUserKhuzela()" [ngStyle]="{color:new?.club?.color}">{{new?.club?.name}}</td>
                  <td>
                    <span *ngIf="new.status?.name==='Activo'"
                      class="label label-success">{{new?.status?.name}}</span>

                    <span *ngIf="new.status?.name==='Suspenso'"
                      class="label label-danger">{{new?.status?.name}}</span>
                  </td>

                  <ng-actions-table-bar>
                    <ng-button
                      title="Editar"
                      (click)="edit(new)"
                      [button]="{faIconClass:'fa fa-edit',color:'danger'}"
                    ></ng-button>
                    <ng-button
                      title="Detalhe"
                      (click)="detail(new)"
                      [button]="{faIconClass:'fa fa-eye',color:'danger'}"
                    ></ng-button>
                    <ng-button
                     *ngIf="isAdminOrManager()"
                      title="Excluir"
                      (click)="delete(new)"
                      [button]="{faIconClass:'fa fa-close',color:'danger'}"
                    ></ng-button>
                  </ng-actions-table-bar>

                </tr>

          </ng-table>
                    <!-- fim da tabela -->
                    <box-loading class="overlay" *ngIf="isSpinnerLoading"></box-loading>
        </ng-container>
 <!-- fim do conteudo -->
      </ng-box>
    </div>
  </div>
</section>
